module.exports = {
  app: "app",
  outlook: "outlook",
  plugin: "plugin"
};